import SvgLogo from 'src/components/icons/logo';
import { imageOptimize } from 'src/service/image';

interface Props {
  imgs?: Array<string>;
  className?: string;
  width: string;
  height: string;
  letter?: string;
  letterRandom?: boolean;
}

const Avatars = ({
  imgs = [],
  className = '',
  height,
  width,
  letter,
  letterRandom = false,
}: Props) => {
  return (
    <div
      className={`${className} flex -space-x-1 relative z-0 overflow-hidden`}
    >
      {imgs.map((img, key) => {
        const mkey = `key_${key}`;
        if (img === '') {
          return (
            <span
              style={{ width, height }}
              key={mkey}
              className={`relative z-${
                3 - key
              }0  rounded-full ring-0 bg-black  border border-white`}
            >
              {letterRandom || letter}
              <SvgLogo
                alt="1TM Logo"
                margin="auto"
                top={0}
                bottom={0}
                right={0}
                left={0}
                position="absolute"
                className="svg-logo-size text-white "
              />
            </span>
          );
        }

        return (
          <img
            style={{ width, height }}
            key={mkey}
            className={`relative z-${
              3 - key
            }0 rounded-full ring-0 border border-white`}
            src={imageOptimize({ url: img, imgContainer: 'avatar' })}
            alt=""
          />
        );
      })}
    </div>
  );
};
export default Avatars;
